/** interface for populating dynamic configuration using the config json file  */
export interface DynamicConfig {
    zdexerPortalUrl: string;
    polygoncdkUrl: string;
    subgraphUrl: string;
    appTitle: string;
    environment: 'prod' | 'dev' | 'local';
    authEnabled: boolean;
    urls: {
        platform: {
            frontend: string;
            backend: string;
        };
        platformNew: {
            frontend: string;
        };
        protocol: {
            frontend: string;
            backend: string;
        };
        endpoint: {
            wss: string;
            http: string;
        };
        other: {
            frontend: {
                zdfs: string;
                docs: string;
                videos: string;
                helpDesk: string;
                auth: string;
                zdexerPortalUrl: string;
            };
            backend: {
                auth: string;
                inAppNotificationUrl: string;
            };
        };
        
    };
    sharedApiEnabled: boolean;
    zeeveManagedCloud: string;
    contacts: {
        email: string;
    };
    cloudId: string;
    deploymentId: string;
    protocolId: string;
    itemCode: {
        [key: string]: string;
    };
    infraTypes: {
        [key: string]: { cloudId: string; managedHosting: boolean };
    };
    clouds: {
        [key: string]: string;
    };
    token: {
        access: {
            name: string;
            cookieExpiryTimeInMin: number;
            refresTimeInMin: number;
            tempValue: string;
        };
        refresh: {
            name: string;
            tempValue: string;
        };
    };
    module: {
        sidebar: string
      }
    isOrganizationEnabled: boolean  
}

/**
 * class declaration for globally managing the configuration.
 * Note: Default config is null.
 */
class GlobalConfig {
    /** member to hold dynamic config */
    private config: DynamicConfig | null = null;
    /**
     * member to hold json config file path url
     * Note: Please change the file name to config.local.json for local developement purpose.
     */
    private url = 'config.json';

    /** to set the global configuration */
    set setConfig(config: DynamicConfig) {
        this.config = config;
    }

    /** to set the global json file path url */
    set setUrl(url: string) {
        this.url = url;
    }

    /** to get the global configuration */
    get getConfig(): DynamicConfig | null {
        return this.config;
    }

    /** to get the global json file path url */
    get getUrl(): string {
        return this.url;
    }
}

/** class object of global configuration */
const globalConfig = new GlobalConfig();

export default globalConfig;
